module.exports = __webpack_public_path__ + "media/images/referral3-5a1bc66b.png";